export const OPM_AD_BASE_PATH = '/opm-ad';

export const AGENT_QUALIFICATION_DETAIL_REPORT_PATH = '/agent-qualification-detail-report';

export const OPM_AD_TITLE = 'OPM AD';
export const AGENT_QUALIFICATION_DETAIL_REPORT_TITLE = 'Agent Qualification Detail Report';

export const OPM_AD_AGENT_QUALIFICATION_DETAIL_REPORT_NAMESPACE = 'OPM-AD-AGENT-QUALIFICATION-DETAIL-REPORT';

export enum AdminOpmAdPermissionType {
  OPM_AD_AGENT_QUALIFICATION_DETAIL_REPORT_READ = 'READ_ANY_OPM-AD-AGENT-QUALIFICATION-DETAIL-REPORT',
  OPM_AD_AGENT_QUALIFICATION_DETAIL_REPORT_CREATE = 'CREATE_ANY_OPM-AD-AGENT-QUALIFICATION-DETAIL-REPORT',
  OPM_AD_AGENT_QUALIFICATION_DETAIL_REPORT_UPDATE = 'UPDATE_ANY_OPM-AD-AGENT-QUALIFICATION-DETAIL-REPORT',
}
